import { Link, withProps } from '@mna/react'
import LoadingScreen from 'features/LoadingScreen'
import phonecall from 'assets/img/phonecall.png'
import videocall from 'assets/img/videocall.png'
import { Trans } from 'react-i18next'
import { checkAndGetLocalStorageValue } from "../../../features/utils";
import i18next from '../../../i18n'

const Page = ({ state, history, nextStepName, setState, actions }) =>
    <LoadingScreen isLoading={state.isLoading} >
        <div class="content-width mt-3">

            <div class="standby-page-header standby-page-header-center">
                <h1 class="standby-page-header-title"><Trans i18nKey="findcareoption.Careoptions.telemedicine.connectiontype">How would you like to connect with the Doctor?</Trans></h1>
            </div>

            <div class="connection-type row">
                <div class="col-6 text-right connection-type-item">
                    <button type="button" class="button connection-type connection-type-video"
                        onClick={() => {
                            nextStepName = "telemed-videoprompt"
                            state.triageResponse.selectedConnectionType = "2"
                            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                            state.triageRequest.activeMenu = "care-options";
                            history.push(`/find-care-options/${nextStepName}`)
                        }}
                        aria-label={i18next.t("findcareoption.Careoptions.telemedicine.connectiontype")+ " "+ i18next.t("findcareoption.Careoptions.telemedicine.videochat")}>
                        <img alt={i18next.t("findcareoption.Careoptions.telemedicine.videochat")} src={videocall} style={{ height: '62px', width: '62px' }} />
                        <div class="icon icon-size-3"></div>
                        <div ><Trans i18nKey="findcareoption.Careoptions.telemedicine.videochat">Video Chat</Trans></div>
                    </button>
                </div>

                <div class="col-6 text-left connection-type-item">
                    <button type="button" class="button connection-type connection-type-phone"
                        onClick={() => {
                            nextStepName = "telemedicine-info"
                            state.triageResponse.selectedConnectionType = "1"
                            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                            if (state.isTravelAid2) {
                                state.triageRequest.activeMenu = "care-options";
                                actions.updateLogTelemedCordination()
                                history.push(`/find-care-options/telemed-pharma-prompt`)
                            }
                            else {
                                history.push(`/find-care-options/${nextStepName}`)
                            }
                        }}
                        aria-label={i18next.t("findcareoption.Careoptions.telemedicine.connectiontype")+ " "+ i18next.t("findcareoption.Careoptions.telemedicine.phonecall")}>
                        <img alt={i18next.t("findcareoption.Careoptions.telemedicine.phonecall")} src={phonecall} style={{ height: '60px', width: '60px' }} />
                        <div class="icon icon-size-2"></div>
                        <div ><Trans i18nKey="findcareoption.Careoptions.telemedicine.phonecall">Phone Call</Trans></div>
                    </button>
                </div>
            </div>
            <div className="standby-page-header standby-page-header-center">
                <a 
                className="standby-button-back"
                 href="#"
                    onClick={() => {history.push(state.UserNavigatedToQT ? '/find-care-options/quick-telemedicine-screen' : state.isTravelAid2 ? '/find-care-options/symptoms' : '/find-care-options/care-options')
                }}
                onKeyDown={(e) => {
                    if(e.key === "Spacebar" || e.key === "Enter" || e.key === " "){
                        history.push(state.UserNavigatedToQT ? '/find-care-options/quick-telemedicine-screen' : state.isTravelAid2 ? '/find-care-options/symptoms' : '/find-care-options/care-options')
                    }}}>

                    <div className="icon">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 1024 1024"
                        >
                            <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                        </svg>
                    </div>
                    <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">Cancel Request</Trans>
                </a>

            </div>

        </div>

    </LoadingScreen>


export default withProps(props => {

    const { state, setState } = props
    const { triageRequest } = state
    state.triageRequest.activeMenu = "care-options"
    //485:
    console.log(triageRequest.emergency)
    localStorage.setItem('IsEmergencySelected', triageRequest.emergency);
    if (state.isLoading_RelativeSymptom) { setState({ isLoading_RelativeSymptom: false }); }
    const hasCurrentLocation = triageRequest.location.lat && triageRequest.location.lng

    return {
        ...props,
        hasCurrentLocation
    }

})(Page)